import { useEffect } from 'react';

const SCRIPT_ID = 'userway-widget-script';
const ALLOWED_SLUGS = ['dfp-recruitment', 'employerqa', 'vervoe-product'];

export default function UserwayWidget({ slug }) {
    const enabled = ALLOWED_SLUGS.includes(slug);

    useEffect(() => {
        const existingScript = document.getElementById(SCRIPT_ID);

        if (!enabled) {
            if (existingScript) {
                existingScript.remove();
            }
            return;
        }

        if (existingScript) {
            return;
        }

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = 'https://cdn.userway.org/widget.js';
        script.async = true;

        script.setAttribute('data-position', '5');
        script.setAttribute('data-widget_layout', 'full');
        script.setAttribute('data-account', 'MoBQLAJnK8');

        document.body.appendChild(script);

        return () => {
            script.remove();
        };
    }, [enabled]);

    return null;
}
